// Quantity-break cards submit name="quantity" radios; this element disables and
// hides the form's standard quantity selector so only the selected card is sent.
class SQuantityBreaks extends HTMLElement {
  connectedCallback() {
    const form = this.closest('form');
    if (!form) return;
    form.querySelectorAll('[data-qty-standard]').forEach((wrapper) => {
      wrapper.hidden = true;
      wrapper.querySelectorAll('input[name="quantity"]').forEach((input) => {
        input.disabled = true;
      });
    });
  }
}

if (!customElements.get('s-quantity-breaks')) {
  customElements.define('s-quantity-breaks', SQuantityBreaks);
}
